import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const DoctorList = ({ doctors, onSelectMaster, inputSearch, branches }) => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlDoctorId = parseInt(
      urlParams.get("doctorId") && urlParams.get("doctorId").replace(/"/g, "")
    );
    const urlDoctor = doctors.find((doctor) => doctor.Id === urlDoctorId);
    if (urlDoctor) {
      onSelectMaster(
        urlDoctor.Name,
        urlDoctor.Id,
        urlDoctor.DefaultTime,
        [
          {
            id: urlDoctor.Id,
            name: urlDoctor.SpecialityName,
          },
        ],
        urlDoctor.Photo,
        urlDoctor.IdSpeciality
      );
    }
  }, [doctors, onSelectMaster]);

  const selectedSpeciality = useSelector(
    (s) => s.doctorTabsReducer.doctorTab
  ).toLowerCase();

  const selectedBranch = useSelector(
    (s) => s.branchTabsReducer.branchTab
  ).toLowerCase();

  return doctors
    .filter((doctor) => {
      const specialityFilter =
        selectedSpeciality === "все" ||
        selectedSpeciality === doctor.SpecialityName.toLowerCase();

      const branchFilter =
        selectedBranch === "все" ||
        (doctor.Branch && doctor.Branch.toLowerCase() === selectedBranch);

      const searchFilter = doctor.Name.toLowerCase().includes(inputSearch);
      // добавляем фильтр по AllowOnlineAppointment
      const allowOnline = doctor.AllowOnlineAppointment === true;

      return specialityFilter && branchFilter && searchFilter && allowOnline;
    })
    .sort((a, b) => {
      if (a.Name > b.Name) return 1;
      if (a.Name < b.Name) return -1;
      return 0;
    })
    .map((doctor) => {
      const date = new Date(doctor.NearestFreeTime);
      const options = {
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      };

      const branch = branches.find((branch) => branch.Name === doctor.Branch);

      const specialities = [
        {
          id: doctor.Id,
          name: doctor.SpecialityName,
        },
      ];

      return (
        <div
          key={doctor.Id}
          className="choose-master-root__master"
          onClick={() =>
            onSelectMaster(
              doctor.Name,
              doctor.Id,
              doctor.DefaultTime,
              specialities,
              doctor.Photo,
              doctor.PhoneNumber,
              doctor.IdSpeciality
            )
          }
        >
          <div className="d-flex">
            <div className="choose-master-root__avatar">
              {doctor.Photo ? (
                <img
                  src={`data:image/png;base64,${doctor.Photo}`}
                  alt=""
                  style={{
                    width: "78px",
                    height: "78px",
                    borderRadius: "15px",
                    border: "none",
                    objectFit: "cover",
                  }}
                />
              ) : (
                doctor.Name.charAt().toUpperCase()
              )}
            </div>
            <div className="d-flex flex-column">
              <div className="choose-master-root__master-name">
                {doctor.Name.toLowerCase()}
              </div>
              <p className="choose-master-root__speciality">
                {doctor.SpecialityName}
              </p>
              {doctor.NearestFreeTime ? (
                <div className="choose-master-root__time">
                  <p>
                    Ближ. прием {`${date.toLocaleDateString("ru", options)}`}
                  </p>
                </div>
              ) : null}
              <div className="choose-master-root__address">
                {branch ? <p>{branch.Name}</p> : <p>Филиал не указан</p>}
              </div>
            </div>
          </div>
        </div>
      );
    });
};

DoctorList.propTypes = {
  doctors: PropTypes.array.isRequired,
  onSelectMaster: PropTypes.func.isRequired,
  inputSearch: PropTypes.string.isRequired,
  branches: PropTypes.array.isRequired,
};

export default DoctorList;
